import React, {useEffect,useState} from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { connect, ConnectedProps } from 'react-redux';
import { genericAction } from '../../features/pacticipantOutcomeSlice';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { getEmployers } from 'src/services/outcomes.service';
import axios from 'axios';
import './CustomSearchAutocomplete.css';


let source

interface Item {
  label: string;
}

const mapStateToProps = (state: any) => ({
  employers: state.participantOutcome.employers,
  jobPlacementEmployer: state.participantOutcome.jobPlacementEmployer,
  incumbentEmployer: state.participantOutcome.incumbentEmployer,
  internshipEmployer: state.participantOutcome.internshipEmployer,
  selectedEmployerId: state.participantOutcome.selectedEmployerId,
});

const mapDispatchToProps = { genericAction };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface CustomSearchAutocompleteProps extends WithStyles<typeof styles>, PropsFromRedux  {
  label?: string;
  required?: boolean;
  placeholder?: string;
  name: string;
}



const CustomSearchAutocomplete: React.FC<CustomSearchAutocompleteProps> = (props) => {
  const {employers,label,name,placeholder,required, classes,jobPlacementEmployer,incumbentEmployer,internshipEmployer} = props
  const [value, setValue] = useState(props[name] || '');
  const [items, setItems] = useState<Item[]>([]);

  useEffect(() => {
    console.log(`useEffect internshipEmployer = ${props.internshipEmployer}`)
    console.log(`useEffect incumbentEmployer = ${props.incumbentEmployer}`)
    console.log(`useEffect jobPlacementEmployer = ${props.jobPlacementEmployer}`)
    console.log(`useEffect value = ${value}`)
    if(!value || value.length==0){
      setValue(props[name])
    }
  },[jobPlacementEmployer,incumbentEmployer,internshipEmployer])


  useEffect(() => {
    if (employers?.length) {
      setItems(employers.map((employer: any) => ({ name: employer.employer_name,id:parseInt(employer.id) })));
    }
    console.log(items)
    

  }, [employers]);

  useEffect(() => {
    let valueCopy = value?.trim().toLowerCase()
    if (valueCopy?.length>1) {
      if(source && employers?.length>1){
        try {
          source.cancel('Operation canceled by the user.')
        } catch (error) {
          
        }
      }
      source = axios.CancelToken.source();
        if (employers && employers.length > 0) {
          
          let filteredEmployers = employers.filter((employer:any)=> employer?.employer_name?.toLowerCase().trim().includes(valueCopy)) 
          console.log(`fileredEmployers = ${JSON.stringify(filteredEmployers)}`)
          setItems(filteredEmployers.map((employer: any) => ({ name: employer.employer_name,id:parseInt(employer.id), city:employer.city })));
        }
    }
    updateValueInState(value)
  }, [value,employers]);

  /* useEffect(()=>{
    setTimeout(()=>{
      setValue(props[name] || '')
    },500)
  },[]) */

  const handleOnSearch = (string: string, results: any) => {
    debugger
    setValue(string)
    console.log(string)
    console.log(`results: ${results}`);
    if(props.name === 'jobPlacementEmployer'){
      props.genericAction({ selectedEmployerId: null });
    }
    updateValueInState(string)
  };

  const handleOnSelect = (item: any) => {
    console.log(item);
    updateValueInState(item?.name)
    if(props.name === 'jobPlacementEmployer'){
      props.genericAction({ selectedEmployerId: item.id });
    }
  };

  const updateValueInState = (val: string) => {
    props.genericAction({ [props.name]: val });
  }
  console.log(`CustomSearchAutocomplete rendered`);
  console.log(`CustomSearchAutocomplete rendered name=${name} props[name]=${props[name]}`)
  console.log(`internshipEmployer = ${props.internshipEmployer}`)
  console.log(`incumbentEmployer = ${props.incumbentEmployer}`)
  console.log(`jobPlacementEmployer = ${props.jobPlacementEmployer}`)

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>{item.name} - {item.city}</span> */}
        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
      </>
    )
  }

  return (
    <>
      <div className={classes.root}>
        <div className={classes.label} style={{ padding: '4px' }}>
          {label}: {props.required && <span className={classes.requiredField}>*</span>}
        </div>
        <div className={`${classes.dropDownWrapper}`} style={{ padding: '4px 0' ,position: 'relative'}}>
          <ReactSearchAutocomplete
            className='custom-search-autocomplete-component'
            inputSearchString={value}
            items={items}
            onSearch={handleOnSearch}
            onSelect={handleOnSelect}
            placeholder={"Start typing Employer name to get suggestions or type complete name"}
            showItemsOnFocus={false}
            showNoResults={false}
            styling={{
              zIndex: 2,
              searchIconMargin: '0', 
              clearIconMargin: '0',
            }} 
            maxResults = {employers.length}
            autoFocus={false}
            formatResult={formatResult}
          />
        </div>
      </div>
      {/* {(name=== 'jobPlacementEmployer' && props.selectedEmployerId!=null) && (<div className={classes.noteDiv}>
          <span style={{ padding: '4px' }} className={classes.noteSpan1}></span>
          <span className={classes.noteSpan2}>Note: Address can be changed if it is not participant's actual work location</span>
        </div>)} */}
    </>
  );
};


const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      flexWrap: 'wrap',
      position: 'relative', // Ensure the root container has relative positioning
    },
    progress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: '-20px',
      marginLeft: '-20px',
    },
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
    },
    forms: {
      display: 'flex',
      justifyContent: 'center',
    },
    formWrapper: {
      flexBasis: '65%',
      [theme.breakpoints.down('md')]: {
        flexBasis: '95%',
      },
    },
    full: {
      flexGrow: 1,
    },
    requiredField: {
      color: 'red',
    },
    label: {
      flexBasis: '25%',
      justifyContent: 'flex-end',
      display: 'flex',
      paddingRight: '8px',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
        justifyContent: 'flex-start',
      },
    },
    dropDownWrapper: {
      flexGrow:1,
      flexBasis: '30%',
      [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
      },
    },
    autocomplete:{
      width:'100%'
    },
    noteSpan1:{
      flexBasis: '25%',
      justifyContent: 'flex-end',
    },
    noteSpan2:{
      color: 'blue',
      fontStyle: 'italic',
      flexGrow: 1,
      flexBasis: '30%',
    },
    noteDiv:{
      display: 'flex',
      
    }
  });

export default connector(withStyles(styles)(CustomSearchAutocomplete));